import client, {gisClient} from "api/client";

export const fetcher = (url: string) => client.get(url)
                                              .then((res) => res?.data);
export const fetcherGis = (url: string) => gisClient.get(url)
                                                    .then((res) => res?.data);
